import { Tree, TreeCheckboxSelectionKeys } from "primereact/tree";
import { TreeNode } from "primereact/treenode";

interface OrganizationSectorsStepProps {
  sectorTreeNodes: TreeNode[];
  selectedOrgSectors: TreeCheckboxSelectionKeys | null;
  expandedKeys: Record<string, boolean>;
  isLoading: boolean;
  selectedSectorLabels: string[];
  onSelectionChange: (nodes: TreeCheckboxSelectionKeys | null) => void;
  onExpandedChange: (keys: Record<string, boolean>) => void;
  onRemoveSector: (sector: string) => void;
  onSubmit: () => void;
  onSkip: () => void;
  submitPartnerOnly?: boolean;
}

export const OrganizationSectorsStep = ({
  sectorTreeNodes,
  selectedOrgSectors,
  expandedKeys,
  isLoading,
  selectedSectorLabels,
  onSelectionChange,
  onExpandedChange,
  onRemoveSector,
  onSubmit,
  onSkip,
  submitPartnerOnly,
}: OrganizationSectorsStepProps) => {
  return (
    <div className="step-content step-7">
      <div className="step-header">
        <p className="step-subtitle">Create your organisation</p>
        <h2 className="step-title">What are your sectors?</h2>
      </div>

      {selectedSectorLabels.length > 0 && (
        <div className="selected-interests">
          {selectedSectorLabels.map((sector) => (
            <div key={sector} className="interest-chip">
              <span>{sector}</span>
              <button type="button" onClick={() => onRemoveSector(sector)}>
                <i className="pi pi-times"></i>
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="form-group">
        <div className="interests-tree-container">
          {isLoading ? (
            <div style={{ textAlign: "center", padding: "2rem" }}>
              <p>Loading sectors...</p>
            </div>
          ) : (
            <Tree
              value={sectorTreeNodes}
              selectionMode="checkbox"
              selectionKeys={selectedOrgSectors}
              onSelectionChange={(e) =>
                onSelectionChange(e.value as TreeCheckboxSelectionKeys)
              }
              expandedKeys={expandedKeys}
              onToggle={(e) => onExpandedChange(e.value)}
              className="interests-tree"
              filter
              filterPlaceholder="Search sectors..."
            />
          )}
        </div>
      </div>

      <button type="button" className="submit-button" onClick={onSubmit}>
        Continue
      </button>

      {!submitPartnerOnly && (
        <button type="button" className="skip-button" onClick={onSkip}>
          Do it later
        </button>
      )}
    </div>
  );
};
